import React from "react";
import { useEffect } from "react";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { makeSpaBooking } from "../../../action/spaBooking";
import { formatDateAsDateFormat } from "./spaBooking3";
import moment, { duration } from "moment";
import { formatLocalTime, makeStringStrictlyCapitalize, toBool } from "../../JS/utility";
import { formatMinutesToTimeFormat } from "../../JS/utility";
import { formatMinutesToHHMMSS } from "../../JS/utility";
import { scrollToTop } from "../../../JS/scrollToTop";

function SpaBooking3summary(props) {
  const { t } = props;

  useEffect(() => {
    scrollToTop();
  }, []);

  const handleNext = () => {
 
    if (!props.updateReservationDetails) {


      const payload = {
        "serviceType": "spa",
        dateTime: `${props.selectedTechnicianDetails.availableDate}T${formatMinutesToHHMMSS(props.selectedTechnicianDetails.startTime)}`,
        serviceId: JSON.parse(props.selectedServiceId),
        spaLocationId: props.spaLocationId,
        technicianId: props.selectedTechnicianDetails.technicianId,
        guestNotes: props.additionalDetails.guestNotes,
        requestedType: props.preferences.gender,
        addOnServiceId: props.selectedAddon.reduce((acc,curr)=>{acc.push(curr.id); return acc;},[]),
        spaServicePrice: props.selectedService.service.price + props.selectedAddon.reduce((acc,curr)=>{  return acc + curr.price;},0),
        spaTechnicianPrice: props.selectedTechnicianDetails.technicianPrice,
        duration:props.selectedService.service.duration
     
      };

      

      if (props.additionalDetails.mobileNumber) {
        payload['mobileNumber'] = props.additionalDetails.mobileNumber
      }
      if (props.additionalDetails.email) {
        payload['email'] = props.additionalDetails.email
      }
      console.log("makespabooking payload", payload);
      props.handleMakeReservation(payload);

    } else {

      const payload = {
        "serviceType": "spa",
        dateTime: `${props.selectedTechnicianDetails.availableDate}T${formatMinutesToHHMMSS(props.selectedTechnicianDetails.startTime)}`,
        serviceId: JSON.parse(props.selectedServiceId),
        spaLocationId: props.spaLocationId,
        technicianId: props.selectedTechnicianDetails.technicianId,
        guestNotes: props.additionalDetails.guestNotes,
        appointmentId: props.updateReservationDetails.id,
        addOnServiceId:props.selectedAddon.reduce((acc,curr)=>{acc.push(curr.id); return acc;},[]),
        spaServicePrice: props.selectedService.service.price + props.selectedAddon.reduce((acc,curr)=>{  return acc + curr.price;},0),
        spaTechnicianPrice: props.selectedTechnicianDetails.technicianPrice,
        duration:props.selectedService.service.duration
      

      };
      console.log("updatespabooking payload", payload);
      props.handleUpdateReservation(payload);

    }
  };


  return (
    <>

      <section class="widgets spa-listing spa-details booking-summary">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}
          <div class="widget-header-title">{t("spaBooking.summary")}</div>
        </div>

        {props.selectedService && 

          <>
        <div class="detail-body stay-body">
          <div class="stay-info">
            <div class="stay-arrival">
              <div class="heading">{t("spaBooking.date")}</div>
              <div class="body">
                <p>
                  {" "}
                  {
                    moment(props.selectedTechnicianDetails.availableDate).format((props.dateFormat).toUpperCase())
                  }


                </p>
              </div>
            </div>
            <div class="stay-arrival">
              <div class="heading">{t("spaBooking.time")}</div>
              <div class="body">
                <p>

                  {
                    formatMinutesToTimeFormat(props.selectedTechnicianDetails.startTime, toBool(props.timeFormat))
                  }
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row additional_details">
          <div class="col">
            <div class="detail-body stay-body">
              <form>
                <div class="form-row spa-summary">
                  <p class="heading">{t("spaBooking.details")}</p>
                  <label>
                  <span class="list-name">{t("spaBooking.treatment")}</span> <span>{makeStringStrictlyCapitalize(props.selectedService.name)}</span>
                  </label>
                  <label>
                    {t("spaBooking.duration")}{" "}
                    <span>{props.selectedService.service.duration} {t("spaBooking.min")}</span>
                  </label>
                  <label className="spa-technician_name"> 
                  <span class="list-name">
                    {t("spaBooking.therapist")}{" "}
                    </span>
                    <span>
                      {props.selectedTechnicianDetails.technicianName}
                    </span>
                  </label>
                </div>


                <div class="form-row price-total base-price">
                  <label>
                  <span class="list-name">
                    {t("spaBooking.base_price")}
                    </span>
                    <span>
                      {props.currencyCode}{" "}
                      {props.selectedService.service.price}
                    </span>
                  </label>
                </div>
                
                <div class="form-row price-total enhancement-summary">
                  <label>
                  <span class="list-name">
                    {t("spaBooking.enhancements")+" [" +  
                      (props.selectedAddon.length>0 
                      ?
                          props.selectedAddon.reduce((acc,curr,index)=>{
                            
                            if(props.selectedAddon.length-1!=index){
                              return acc+curr.name +", "
                            }
                            return acc+ curr.name;
                          },"")
                      :
                      "No enhancement selected ")
                      +
                      "]"
                    }
                    </span>
                    <span>
                       
                      {props.currencyCode}{" "}
                      {props.selectedAddon.reduce((acc,curr)=>{  return acc+ curr.price;},0)}
                    </span>
                  </label>
                </div>


                <div class="form-row price-total therapist-cost">
                  <label>
                  <span class="list-name">
                    {t("spaBooking.therapist_cost")}
                    </span>
                    <span>
                      {props.currencyCode}{" "}
                      {props.selectedTechnicianDetails.technicianPrice}
                    </span>
                  </label>
                </div>


                <div class="form-row price-total final-price">
                  <label>
                  <span class="list-name">
                    { ( + t("spaBooking.total_price_display.showChargesLabel") ) ? t("spaBooking.total_price_display.textWithChargesLabel").replace("XX",props.chargesDetails.tax).replace("YY",props.chargesDetails.serviceCharge) :  t("spaBooking.total_price_display.textWithoutChargesLabel") }
                    </span>
                    <span>
                      {props.currencyCode}{" "}
                      {`${(props.selectedTechnicianDetails.technicianPrice > 0
                          ? props.selectedService.service.price +
                          props.selectedTechnicianDetails.technicianPrice +
                          props.selectedAddon.reduce((acc,curr)=>{  return acc+ curr.price;},0)
                          :((props.selectedService.service.price + props.selectedAddon.reduce((acc,curr)=>{  return acc+ curr.price;},0))) || "")
                        }`}
                      <span class="spa-price-per-person 3sum">{t("spaBooking.per_person")}</span>
                    </span>
                  </label>
                </div>


                {/* //showing only service price */}
                {/* <div class="form-row price-total">
                  <label>
                  <span class="list-name">
                    {t("spaBooking.service_price")}
                    </span>
                    <span>
                      {props.currencyCode}{" "}
                      {props.selectedService.service.price}
                    </span>
                  </label>
                </div> */}

              </form>
            </div>
          </div>
        </div>
        </>
        }

        <div class="row">
          <div class="form-controls">
            <button onClick={handleNext}>
              {props.updateReservationDetails ? t("spaBooking.update_reservation_button") : t("spaBooking.make_reservation")}
            </button>
            <button onClick={props.handleBack}>{t("spaBooking.back")}</button>
          </div>
        </div>
      </section>



    </>
  );
}

const mapStateToProps = (state) => {
  return {
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    currencyCode: state.store.home.clientConfig.currencyDetails
      ? state.store.home.clientConfig.currencyDetails.code
      : "",
    timeFormat:
      state.store.home.clientConfig.extraConfigParam &&
      state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
  };
};

export default connect(mapStateToProps)(
  withTranslation("translations")(SpaBooking3summary)
);
